import saneamento from './saneamento'
import cadastros from './cadastros'

export default [
  ...cadastros,
  ...saneamento,
];
